export default "<!-- View/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n"